module.exports = __webpack_public_path__ + "media/icons/minus-e8c7dae1.svg";